(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["grandora-home-experience"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-g3]').forEach((root)=>{const slides=[...root.querySelectorAll('[data-g3-slide]')],dots=[...root.querySelectorAll('[data-g3-dot]')];if(!slides.length)return;let current=0,timer;const show=(n)=>{current=(n+slides.length)%slides.length;slides.forEach((s,i)=>{const active=i===current;s.hidden=!active;s.classList.toggle('active',active);s.setAttribute('aria-hidden',active?'false':'true')});dots.forEach((d,i)=>{d.classList.toggle('active',i===current);d.setAttribute('aria-current',i===current?'true':'false')})};const play=()=>{clearInterval(timer);if(slides.length>1&&!window.matchMedia('(prefers-reduced-motion: reduce)').matches)timer=setInterval(()=>show(current+1),5000)};show(0);if(slides.length<2)return;root.querySelector('[data-g3-prev]')?.addEventListener('click',()=>{show(current-1);play()});root.querySelector('[data-g3-next]')?.addEventListener('click',()=>{show(current+1);play()});dots.forEach(d=>d.addEventListener('click',()=>{show(Number(d.dataset.g3Dot));play()}));root.addEventListener('mouseenter',()=>clearInterval(timer));root.addEventListener('mouseleave',play);root.addEventListener('focusin',()=>clearInterval(timer));root.addEventListener('focusout',play);play()});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["grandora-home-v4"] && !Shopify.designMode) return;
  try {
    
function initGrandoraHomeV4(scope = document) {
  scope.querySelectorAll('[data-g4-home]:not([data-g4-ready])').forEach(root => {
    root.dataset.g4Ready = 'true';
    const slides = [...root.querySelectorAll('[data-g4-slide]')];
    if (slides.length < 2) return;
    let current = 0, timer, paused = false;
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    const pause = root.querySelector('[data-g4-pause]');
    const dots = root.querySelector('[data-g4-dots]');
    slides.forEach((slide, index) => {
      const dot = document.createElement('button');
      dot.type = 'button';
      dot.setAttribute('aria-label', slide.querySelector('.g4-hero-copy h1, .g4-hero-copy h2').textContent);
      dot.addEventListener('click', () => { show(index); play(); });
      dots.append(dot);
    });
    const show = index => {
      current = (index + slides.length) % slides.length;
      slides.forEach((slide, i) => { slide.hidden = i !== current; slide.inert = i !== current; slide.classList.toggle('is-active', i === current); });
      [...dots.children].forEach((dot, i) => { dot.classList.toggle('is-active', i === current); dot.setAttribute('aria-current', String(i === current)); });
      root.querySelector('[data-g4-count]').textContent = `${current + 1} / ${slides.length}`;
    };
    const stop = () => clearInterval(timer);
    const play = () => {
      stop();
      if (!paused && !reduced.matches && !document.hidden && !root.matches(':hover') && !root.contains(document.activeElement)) timer = setInterval(() => show(current + 1), 6000);
    };
    root.querySelector('[data-g4-prev]').addEventListener('click', () => { show(current - 1); play(); });
    root.querySelector('[data-g4-next]').addEventListener('click', () => { show(current + 1); play(); });
    pause.addEventListener('click', () => { paused = !paused; pause.textContent = paused ? '▷' : 'Ⅱ'; pause.setAttribute('aria-pressed', String(paused)); pause.setAttribute('aria-label', paused ? pause.dataset.playLabel : pause.dataset.pauseLabel); play(); });
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', play);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', () => setTimeout(play, 0));
    let touchX = 0, touchY = 0;
    const hero = root.querySelector('.g4-hero');
    hero.addEventListener('touchstart', e => { touchX = e.changedTouches[0].clientX; touchY = e.changedTouches[0].clientY; }, { passive: true });
    hero.addEventListener('touchend', e => { const dx = e.changedTouches[0].clientX - touchX; const dy = e.changedTouches[0].clientY - touchY; if (Math.abs(dx) > 55 && Math.abs(dx) > Math.abs(dy)) { show(current + (dx < 0 ? 1 : -1)); play(); } }, { passive: true });
    const visibility = () => { if (!root.isConnected) { stop(); document.removeEventListener('visibilitychange', visibility); } else play(); };
    document.addEventListener('visibilitychange', visibility);
    reduced.addEventListener('change', play);
    root.closest('.shopify-section')?.addEventListener('shopify:section:unload', () => { stop(); document.removeEventListener('visibilitychange', visibility); reduced.removeEventListener('change', play); });
    show(0); play();
  });
}
initGrandoraHomeV4();
document.addEventListener('shopify:section:load', event => initGrandoraHomeV4(event.target));
document.addEventListener('shopify:block:select', event => { const slide = event.target.closest('[data-g4-slide]'); const root = slide?.closest('[data-g4-home]'); if (root) { const index = [...root.querySelectorAll('[data-g4-slide]')].indexOf(slide); root.querySelector('[data-g4-dots]')?.children[index]?.click(); } });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["grandora-product-v3"] && !Shopify.designMode) return;
  try {
    
function initGrandoraProduct(root=document){
root.querySelectorAll('.gp3:not([data-gp-ready])').forEach(section=>{
section.dataset.gpReady='true';
const gallery=section.querySelector('[data-gp-gallery]');
const main=gallery?.querySelector('.gp3-main-image');
const thumbs=Array.from(gallery?.querySelectorAll('[data-gp-image]')||[]);
let active=0;
if(main&&thumbs.length){
const dialog=document.createElement('dialog');
dialog.className='gp3-lightbox';
dialog.setAttribute('aria-label',section.dataset.galleryLabel);
dialog.innerHTML='<button type="button" class="gp3-lightbox-close">×</button><button type="button" class="gp3-lightbox-prev">‹</button><img class="gp3-lightbox-image" alt=""><button type="button" class="gp3-lightbox-next">›</button><span class="gp3-lightbox-count" aria-live="polite"></span>';
section.append(dialog);
const enlarged=dialog.querySelector('img');
const close=dialog.querySelector('.gp3-lightbox-close');
const previous=dialog.querySelector('.gp3-lightbox-prev');
const next=dialog.querySelector('.gp3-lightbox-next');
close.setAttribute('aria-label',section.dataset.closeLabel);
previous.setAttribute('aria-label',section.dataset.previousLabel);
next.setAttribute('aria-label',section.dataset.nextLabel);
previous.hidden=next.hidden=thumbs.length<2;
const updateModal=()=>{enlarged.src=thumbs[active].dataset.gpImage;enlarged.alt=main.alt;dialog.querySelector('.gp3-lightbox-count').textContent=(active+1)+' / '+thumbs.length;};
const show=index=>{
active=(index+thumbs.length)%thumbs.length;
main.srcset=thumbs[active].dataset.gpSrcset||'';
main.src=thumbs[active].dataset.gpImage;
thumbs.forEach((thumb,i)=>{thumb.classList.toggle('is-active',i===active);if(i===active)thumb.setAttribute('aria-current','true');else thumb.removeAttribute('aria-current');});
if(dialog.open)updateModal();
};
thumbs.forEach((thumb,i)=>thumb.addEventListener('click',()=>show(i)));
gallery.querySelector('[data-gp-prev]')?.addEventListener('click',()=>show(active-1));
gallery.querySelector('[data-gp-next]')?.addEventListener('click',()=>show(active+1));
main.tabIndex=0;main.setAttribute('role','button');main.setAttribute('aria-label',section.dataset.openLabel);main.setAttribute('aria-haspopup','dialog');
let previousOverflow='';
const open=()=>{updateModal();previousOverflow=document.documentElement.style.overflow;dialog.showModal();document.documentElement.style.overflow='hidden';close.focus();};
main.addEventListener('click',open);
main.addEventListener('keydown',event=>{if(event.key==='Enter'||event.key===' '){event.preventDefault();open();}});
close.addEventListener('click',()=>dialog.close());
dialog.addEventListener('close',()=>{document.documentElement.style.overflow=previousOverflow;main.focus();});
dialog.addEventListener('click',event=>{if(event.target===dialog)dialog.close();});
previous.addEventListener('click',()=>show(active-1));next.addEventListener('click',()=>show(active+1));
const keys=event=>{if(event.key==='ArrowLeft'){event.preventDefault();show(active-1);}if(event.key==='ArrowRight'){event.preventDefault();show(active+1);}};
gallery.addEventListener('keydown',keys);dialog.addEventListener('keydown',keys);
for(const target of [gallery,dialog]){let x=0;let y=0;target.addEventListener('touchstart',event=>{x=event.changedTouches[0].clientX;y=event.changedTouches[0].clientY;},{passive:true});target.addEventListener('touchend',event=>{const dx=event.changedTouches[0].clientX-x;const dy=event.changedTouches[0].clientY-y;if(Math.abs(dx)>45&&Math.abs(dx)>Math.abs(dy))show(active+(dx<0?1:-1));},{passive:true});}
}
const form=section.querySelector('.gp3-form');if(!form)return;
const input=form.querySelector('[name="quantity"]');
const selector=form.querySelector('select[name="id"]');
const hidden=form.querySelector('input[name="id"]');
if(selector&&hidden)hidden.disabled=true;
const variants=JSON.parse(section.querySelector('[data-gp-product]').textContent);
const format=JSON.parse(section.querySelector('[data-gp-money]').textContent);
const money=cents=>{
const token=format.match(/\x7b\x7b\s*(\w+)\s*\x7d\x7d/);
const kind=token?.[1]||'amount';
const decimals=kind.includes('no_decimals')?0:2;
const separator=kind.includes('comma_separator')?',':'.';
const thousands=kind.includes('space_separator')?' ':kind.includes('apostrophe_separator')?"'":separator===','?'.':',';
const parts=(cents/100).toFixed(decimals).split('.');parts[0]=parts[0].replace(/\B(?=(\d{3})+(?!\d))/g,thousands);
return format.replace(/\x7b\x7b\s*\w+\s*\x7d\x7d/,parts.join(separator));
};
const setMoney=(element,cents)=>{if(element)element.innerHTML=money(cents);};
const update=()=>{
const min=Number(input.min)||1;const step=Number(input.step)||1;const max=input.max?Number(input.max):Infinity;
let quantity=Number(input.value);if(!Number.isFinite(quantity))quantity=min;
quantity=Math.min(max,Math.max(min,min+Math.floor((quantity-min)/step)*step));input.value=quantity;
const variant=variants.find(item=>String(item.id)===String(selector?.value||hidden?.value))||variants[0];
setMoney(section.querySelector('[data-gp-unit-price]'),variant.price);
let compare=section.querySelector('[data-gp-compare]');
if(variant.compare_at_price>variant.price){if(!compare){compare=document.createElement('s');compare.dataset.gpCompare='';section.querySelector('.gp3-price').append(compare);}compare.hidden=false;setMoney(compare,variant.compare_at_price);}else if(compare)compare.hidden=true;
setMoney(section.querySelector('[data-gp-total]'),variant.price*quantity);
setMoney(section.querySelector('[data-gp-button-total]'),variant.price*quantity);
form.querySelector('[data-gp-qty-minus]').disabled=quantity<=min;form.querySelector('[data-gp-qty-plus]').disabled=quantity>=max;
const add=form.querySelector('.gp3-add');add.disabled=!variant.available;const label=add.querySelector('[data-gp-add-label]');if(label)label.textContent=variant.available?section.dataset.addLabel:section.dataset.soldLabel;
};
form.querySelector('[data-gp-qty-minus]').addEventListener('click',()=>{input.value=Number(input.value||1)-(Number(input.step)||1);input.dispatchEvent(new Event('change',{bubbles:true}));});
form.querySelector('[data-gp-qty-plus]').addEventListener('click',()=>{input.value=Number(input.value||1)+(Number(input.step)||1);input.dispatchEvent(new Event('change',{bubbles:true}));});
input.addEventListener('change',update);input.addEventListener('input',()=>{if(input.value!=='')update();});selector?.addEventListener('change',update);update();
});
}
initGrandoraProduct();document.addEventListener('shopify:section:load',event=>initGrandoraProduct(event.target));

  } catch(e) { console.error(e); }
})();
})();
